import { useNavigate } from 'react-router';

import { useI18n } from '@app-velocity/i18n';
import { Button } from '@app-velocity/ui';

export type SuccessMessageProps = {
  projectName?: string;
  projectId?: string;
};

export const SuccessMessage = ({
  projectName,
  projectId,
}: SuccessMessageProps) => {
  const navigate = useNavigate();
  const { t } = useI18n();

  const navigateToWorkspace = () => {
    navigate(`workspace/${projectId}`);
  };

  return (
    <>
      <h1>{t('users:project_invitation.success.title')}</h1>
      <p>
        {t('users:project_invitation.success.description', {
          projectName,
        })}
      </p>

      <Button
        variant="contained"
        fullWidth
        color="primary"
        size="large"
        onClick={navigateToWorkspace}
      >
        {t('users:project_invitation.success.go_to_workspace')}
      </Button>
    </>
  );
};
